export function roles(rootGetters) {
  return (rootGetters.roles && rootGetters.roles) || []
}

export function hasAdminRole(rootGetters) {
  return roles(rootGetters).includes('admin')
}

export function allowedRoles(rootGetters, allowed) {
  if (hasAdminRole(rootGetters)) {
    return true
  } else {
    let a = new Set(roles(rootGetters))
    let b = new Set(allowed)
    let intersection = new Set([...a].filter(x => b.has(x)))
    return intersection.size > 0
  }
}

export default {
  getters: {
    isAdmin(state, getters, rootState, rootGetters) {
      return hasAdminRole(rootGetters)
    },
    notAdmin(state, getters, rootState, rootGetters) {
      return !hasAdminRole(rootGetters)
    },
    canMembersView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['members-edit', 'members-view'])
    },
    canMembersEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['members-edit'])
    },
    canConfigsView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['configs-edit', 'configs-view'])
    },
    canConfigsEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['configs-edit'])
    },
    canScoreboardFlipView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['scoreboardflip-view', 'scoreboardflip-edit', 'scoreboardflip-publish'])
    },
    canScoreboardFlipEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['scoreboardflip-edit'])
    },
    canScoreboardFlipPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['scoreboardflip-publish'])
    },
    canEpgContentConfigView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['epgcontent-view', 'epgcontent-edit', 'epgcontent-publish'])
    },
    canEpgContentConfigEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['epgcontent-edit'])
    },
    canEpgContentConfigPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['epgcontent-publish'])
    },
    canAssetManagerView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['assets-view', 'assets-edit', 'assets-publish'])
    },
    canAssetManagerEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['assets-edit'])
    },
    canAssetManagerPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['assets-publish'])
    },
    canTeamMashupView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['team-mashup-view', 'team-mashup-edit', 'team-mashup-publish'])
    },
    canTeamMashupEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['team-mashup-edit'])
    },
    canTeamMashupPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['team-mashup-publish'])
    },
    canBannersView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['banners-view', 'banners-edit', 'banners-publish'])
    },
    canBannersEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['banners-edit'])
    },
    canBannersPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['banners-publish'])
    },
    canSeasonsView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['seasons-view', 'seasons-edit', 'seasons-publish'])
    },
    canSeasonsEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['seasons-edit'])
    },
    canSeasonsPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['seasons-publish'])
    },
    canSponsorshipConfigView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['sponsorship-view', 'sponsorship-edit', 'sponsorship-publish'])
    },
    canSponsorshipConfigEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['sponsorship-edit'])
    },
    canSponsorshipConfigPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['sponsorship-publish'])
    },
    canWebviewView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['webview-view', 'webview-edit'])
    },
    canWebviewEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['webview-edit'])
    },
    canWebviewPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['webview-publish'])
    },
    canBrandingView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['branding-view', 'branding-edit'])
    },
    canBrandingEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['branding-edit'])
    },
    canBrandingPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['branding-publish'])
    },
    canAppNavigationView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['app-navigation-view', 'app-navigation-edit'])
    },
    canAppNavigationEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['app-navigation-edit'])
    },
    canAppNavigationPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['app-navigation-publish'])
    },
    canStatsView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['stats-view', 'stats-edit'])
    },
    canStatsEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['stats-edit'])
    },
    canStatsPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['stats-publish'])
    },
    canCDMenuView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['cdmenu-view', 'cdmenu-edit'])
    },
    canCDMenuEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['cdmenu-edit'])
    },
    canCDMenuPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['cdmenu-publish'])
    },
    canMessagesConfigView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['messages-view', 'messages-edit', 'messages-publish'])
    },
    canMessagesEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['messages-edit'])
    },
    canMessagesPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['messages-publish'])
    },
    canPaywallView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['paywall-view', 'paywall-edit', 'paywall-publish'])
    },
    canPaywallEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['paywall-edit'])
    },
    canPaywallPublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['paywall-publish'])
    },
    canMobileUtilPagesView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['mobile-util-pages-view'])
    },
    canStringOverrideView(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['stringoverride-view', 'stringoverride-edit'])
    },
    canStringOverrideEdit(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['stringoverride-edit'])
    },
    canStringOverridePublish(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['stringoverride-publish'])
    },
    canGumboWebSocketDriverDrive(state, getters, rootState, rootGetters) {
      return allowedRoles(rootGetters, ['websocketdriver-drive'])
    },
  },
}
